import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { NavLink, useParams } from 'react-router-dom';

import { Loader, Placeholder } from 'rsuite';

import { retrieve, update } from './actions/AdminCustomForms'

export default function AdminCustomForms() {
  const { server_id, admin_id } = useParams();
  const [CustomFormData, setCustomFormData] = useState([]);
  const [loading, setLoading] = useState(true);


  const dispatch = useDispatch();
  useEffect(() => {
    fetchCustomForm(server_id, admin_id);
  }, [server_id, admin_id]);


  let fetchCustomForm = (server_id, admin_id) => {
    setLoading(true);
    let data = {
      server_id: server_id ? server_id : '',
      admin_id: admin_id ? admin_id : '',
      limit: 1,
      last_id: '',
      first_id: '',
    };
    dispatch(retrieve(data)).then((response) => {
      setLoading(false);
      // console.log(response)
      setCustomFormData(response?.data);
    });
  }

  let handleAccess = (device_id, access) => {
    let data = {
      server_id: server_id ? server_id : '',
      admin_id: admin_id ? admin_id : '',
      device_id: device_id,
      access: access,
    }
    dispatch(update(data)).then((response) => {
      // console.log(response);
      setLoading(false);
      fetchCustomForm(server_id, admin_id);
    });
  }


  let formatDateTime = (date) => {
    return date;
    console.log(date)
    // if(date && date.length > 0 && time && time.length > 0 && format == 'd/m/y H:i a') {
    //   // console.log(date, time)
    //   let tempDay = date.split('/')[0]
    //   let tempMonth = date.split('/')[1]
    //   let tempYear = date.split('/')[2]
    //   let time_ = time.split(' ')[0];
    //   let hour = time_.split(':')[0];
    //   hour = parseInt(time_.split(':')[0]);
    //   let minute = time_.split(':')[1];
    //   if(time.split(' ')[1] == 'PM') {
    //     return new Date(tempYear + '-' + tempMonth + '-' + tempDay + ' ' + (hour < 12 ? hour < 10 ? hour + 12 : hour + 12 : hour) + ':' + minute + ':00').toISOString();
    //   } else {
    //     return new Date(tempYear + '-' + tempMonth + '-' + tempDay + ' ' + (hour < 12 ? '0' + hour : hour) + ':' + minute + ':00').toISOString();
    //   }
    // } else {
    //   return new Date().toISOString();
    // }
  }
  return (
    <>
      {loading ?
        <div>
          <Placeholder.Paragraph rows={8} />
          <Loader center content="loading" />
        </div>
        :
        <>
          <div className='row'>
            <h4 className='fg-theme mb-2 mt-2'>Custom Forms</h4>
            {
              CustomFormData && CustomFormData.length > 0 ?
                CustomFormData.map((val, index) => {
                  return(
                    <div className='col-md-12 col-lg-4 col-sm-12 mt-1'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='container-fluid'>
                            <div className='row'>
                              <div className='col-md-6 text-left'>
                                <h4 className='fg-theme mb-2 mt-2'>{val?.formName ? val?.formName : ''}</h4>
                                {/* <h4 className='fg-theme mb-2 mt-2'>{val?.brand_name ? val?.brand_name : ''}</h4> */}
                              </div>
                              <div className='col-md-6 text-right'>
                                <NavLink to={`/Architecture/Servers/${server_id}/Admin/${admin_id}/AdminCustomForms/${val.id}/VersionHistory`}><button type='button' className='btn btn-primary'><i className='fa fa-angle-right'></i></button></NavLink>
                              </div>
                            </div>
                          </div>
                          <div className='container-fluid'>
                            <p>Job Roles : {val?.jobRole.join(",")}</p>
                            <p>Selected Types : {val?.selectedTypes.join(",")}</p>
                            <p>Create Date : {Date(val?.addedOn)}</p>
                            <p>Type : {val?.type}</p>
                            <p>Status : <i onClick={() => handleAccess(val?.device_id, !val?.active)} className={`fa fa-${val?.active?'toggle-on fg-green':'toggle-off fg-red'}`}></i></p>
                            {/* <p>Access : {val.access?'TRUE':'FALSE'}</p> */}
                            {
                              val?.attachedMedia.map((val2, index2) => (
                                <p><a target='_blank' href={val2}>Attachment {index2+1}</a></p>
                              ))
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              : ''
            }
          </div>
        </>
      }
    </>
  )
}
